/**
 * Internal dependencies
 */
import {
    CURRENT_ROAM_RECEIVE,
    CURRENT_ROAM_REQUEST,
    CURRENT_ROAM_REQUEST_SUCCESS,
    CURRENT_ROAM_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentRoam, requestingCurrentRoam} from 'state/current-roam/selectors';

/**
 * [description]
 *
 * @param  {[type]} roam [description]
 * @return {[type]}         [description]
 */
export const setCurrentRoam = (roam) => {
    return {
        type: CURRENT_ROAM_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentRoam = () => (dispatch) => {
    dispatch({
        type: CURRENT_ROAM_REQUEST,
    });

    return cscom
        .currentRoam()
        .list()
        .then((roam) => {
            dispatch({
                type: CURRENT_ROAM_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_ROAM_RECEIVE,
                payload: {
                    roam,
                },
            });
            return roam;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_ROAM_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_ROAM_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentRoamIfNotRequested = (...props) => async (dispatch, getState) => {
    
    const currentRoam = getCurrentRoam(getState());
    const requesting = requestingCurrentRoam(getState());

    if (!currentRoam && requesting == false) {
        return dispatch(requestCurrentRoam(...props))
    }

    return currentRoam;
}
